<app-entity-hub-tabs [active]="activeType()" [counts]="counts()" (typeChange)="selectType($event)" />

<app-entity-hub-results-header
  [count]="activeCount()"
  [countKnown]="countsKnown()"
  [searchApplied]="searchApplied()"
  [filtersApplied]="filtersApplied()"
  (clear)="clearApplied()"
>
  <app-entity-hub-sort
    [value]="activeSort()"
    [filters]="activeFilters()"
    (valueChange)="selectSort($event)"
    (filtersChange)="selectFilters($event)"
  />
</app-entity-hub-results-header>

<div class="entity-hub-results flex flex-1 flex-col" #entityHubResults>
  @switch (activeType()) {
    @case (StitchType.MESSAGE) {
      <ng-template appMailAppContext>
        <app-messages2-list
          #activeList
          [filters]="messageFilters()"
          [tenantItems]="contact()?.accountId ? [contact()!] : undefined"
          [showLocationBadge]="true"
          [actionsButtonEnabled]="false"
          variant="card"
          [previewedItemId]="previewedItemId()"
          [notFoundTemplate]="emptyState"
          (clickMessage)="openInDP($event)"
          (doubleClickMessage)="openInModal($event.id, StitchType.MESSAGE, $event)"
        />
      </ng-template>
    }
    @case (StitchType.EVENT) {
      <ng-template appCalendarAppContext>
        <app-events-list
          #activeList
          [filters]="eventFilters()"
          [tenantItems]="contact()?.accountId ? [contact()!] : undefined"
          [showLocationBadge]="true"
          [actionsButtonEnabled]="false"
          variant="card"
          [previewedItemId]="previewedItemId()"
          [notFoundTemplate]="emptyState"
          (clickEvent)="openInDP($event)"
          (doubleClickEvent)="openInModal($event.id, StitchType.EVENT, $event)"
        />
      </ng-template>
    }
    @case (StitchType.TASK) {
      <ng-template appTaskingAppContext>
        <app-tasks-list
          #activeList
          [filters]="taskFilters()"
          [tenantItems]="contact()?.accountId ? [contact()!] : undefined"
          [showLocationBadge]="true"
          [actionsButtonEnabled]="false"
          variant="card"
          [previewedItemId]="previewedItemId()"
          [notFoundTemplate]="emptyState"
          (clickTask)="openInDP($event)"
          (doubleClickTask)="openInModal($event.id, StitchType.TASK, $event)"
        />
      </ng-template>
    }
    @case (StitchType.CONTACT) {
      <ng-template appContactsAppContext>
        <app-contacts-list
          #activeList
          [filters]="contactFilters()"
          [tenantItems]="contact()?.accountId ? [contact()!] : undefined"
          [showLocationBadge]="true"
          [actionsButtonEnabled]="false"
          variant="card"
          [previewedItemId]="previewedItemId()"
          [notFoundTemplate]="emptyState"
          (clickContact)="openInDP($event)"
          (doubleClickContact)="openInModal($event.id, StitchType.CONTACT, $event)"
        />
      </ng-template>
    }
    @case (StitchType.NOTE) {
      <ng-template appNotesAppContext>
        <app-notes-list
          #activeList
          [filters]="noteFilters()"
          [tenantItems]="contact()?.accountId ? [contact()!] : undefined"
          [showLocationBadge]="true"
          [actionsButtonEnabled]="false"
          variant="card"
          [previewedItemId]="previewedItemId()"
          [notFoundTemplate]="emptyState"
          (clickNote)="openInDP($event)"
          (doubleClickNote)="openInModal($event.id, StitchType.NOTE, $event)"
        />
      </ng-template>
    }
    @case (StitchType.FILE) {
      <ng-template appFilesAppContext>
        <app-files-list
          #activeList
          [filters]="fileFilters()"
          [tenantItems]="contact()?.accountId ? [contact()!] : undefined"
          [showLocationBadge]="true"
          [actionsButtonEnabled]="false"
          variant="card"
          [previewedItemId]="previewedItemId()"
          [notFoundTemplate]="emptyState"
          (clickFile)="openInDP($event)"
          (doubleClickFile)="openInModal($event.id, StitchType.FILE, $event)"
        />
      </ng-template>
    }
    @case (StitchType.SHEET) {
      <ng-template appSheetsAppContext>
        <app-sheets-list
          #activeList
          [filters]="sheetFilters()"
          [showLocationBadge]="true"
          [actionsButtonEnabled]="false"
          variant="card"
          [previewedItemId]="previewedItemId()"
          [notFoundTemplate]="emptyState"
          (clickSheet)="openInDP($event)"
          (doubleClickSheet)="openInModal($event.id, StitchType.SHEET)"
        />
      </ng-template>
    }
  }
</div>

<ng-template #emptyState>
  <app-no-content-stub [imageSrc]="activeTab().placeholder">
    <p class="text-base font-medium text-gray-900 text-center">No related {{ activeTab().label }}</p>
  </app-no-content-stub>
</ng-template>
